import React from 'react'
import { styled } from 'styled-components'
import Image from 'next/image'
import { useRouter } from 'next/router'

export const PostCard = ({ post }) => {
  const router = useRouter()
  const { thumbnail, title, author, blogUrl } = post

  return (
    <Card onClick={() => router.push(`/blogs/${blogUrl}`)}>
      <ImageContainer>
        <Image 
          src={thumbnail} 
          alt={title}
          layout="fill"
          objectFit="cover"
        />
      </ImageContainer>
      <Content>
        <Title>{title}</Title>
        {author && <Author>By {author}</Author>}
      </Content>
    </Card>
  )
}

const Card = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
`

const Content = styled.div`
  padding: 16px 18px 18px;
`

const Title = styled.h3`
  color: #1a1a1a;
  font-size: 1.1rem;
  font-family: 'Soehne-Leicht', sans-serif;
  margin: 0 0 8px 0;
  line-height: 1.4;
  font-weight: 400;
`

const Author = styled.span`
  color: #888;
  font-size: 0.8rem;
  font-family: 'Soehne-Leicht', sans-serif;
`

